import {planSelected} from '@/analytics/segment'
import useNavigate from '@/hooks/use-navigate'
import {useSignupModal} from '@/providers/signup-modal'
import hasNonEmptyItems from '@/utils/has-non-empty-items'
import {wait} from '@/utils/wait'

import type {Value} from '@/analytics/segment'
import type {TierTypes} from '@/components/pricing'
import type {PricingFragment} from '@/graphql-types'
import type {FormConfig} from '@/types/consents'

interface UsePricingCtasProps {
    formConfig: FormConfig
    signupModalFree: PricingFragment['data']['signup_modal_free']
    signupModalPro: PricingFragment['data']['signup_modal_pro']
    rawDemoPath?: string
}

export const usePricingCtas = ({
    formConfig,
    signupModalFree,
    signupModalPro,
    rawDemoPath,
}: UsePricingCtasProps) => {
    const navigate = useNavigate({rawPath: !!rawDemoPath})
    const {renderSignupModal} = useSignupModal()

    return async (tier: TierTypes) => {
        planSelected({
            value: tier as Value,
        })

        if (tier === 'advanced' || tier === 'beyond') {
            await wait(300)
            navigate(rawDemoPath ?? '/demo')
        } else {
            const modalContent = tier === 'starter' ? signupModalFree : signupModalPro

            if (hasNonEmptyItems(modalContent)) {
                renderSignupModal({
                    ...modalContent[0],
                    image: {
                        url: modalContent[0].image.fluid.base64,
                        dimensions: {
                            width: 80,
                            height: 80,
                        },
                        copyright: null,
                        alt: null,
                    },
                    formConfig,
                    signupProps: {
                        form: 'Pricing',
                        params: {pricing_plan: tier},
                    },
                    highlightedFeatures: [
                        modalContent[0].highlighted_feature_1,
                        modalContent[0].highlighted_feature_2,
                        modalContent[0].highlighted_feature_3,
                    ].filter((item) => Boolean(item)),
                })
            }
        }
    }
}
